import { useMemo } from 'react';
import { getDatePickerDateType } from 'ui';
import type { SlotStart } from 'features/calendar';
import { useFormatTime, useGenerateDefaultReminderHeroImage, useGetDefaultStartTimeSlot } from '../../../hooks';
import type { CreateReminderFormValues } from '../CreateReminderForm';

export const useGetInitialValues = (slotStart?: SlotStart) => {
  const getDefaultStartTimeSlot = useGetDefaultStartTimeSlot();
  const heroImage = useGenerateDefaultReminderHeroImage();
  const formatTime = useFormatTime();

  return useMemo((): Partial<CreateReminderFormValues> => {
    const startDate = getDatePickerDateType(slotStart?.date ?? new Date());
    const date = slotStart?.isTimeSpecific ? slotStart.date : getDefaultStartTimeSlot(startDate);
    const startTime = formatTime(date);

    return {
      heroImage,
      isAllDay: false,
      startDate,
      startTime,
    };
  }, [slotStart, getDefaultStartTimeSlot, formatTime, heroImage]);
};
